import * as React from 'react';
import { GenericToolbar } from '../../../components/GenericToolbar';
import { useLanguageLocale } from '../../../hooks/language-locale-hooks';
import { AddUser } from './AddUser';
import { pushAppRoute } from '../../../data/domain/route-manager';
import { useHistory } from 'react-router-dom';
import { getUserId, useAuthState } from '../../../components/AuthContextProvider';
import { DataProviderCache } from '../../../data/DataProviders/DataProviderCache';
import { RegistrationRoleProvider } from '../../../data/DataProviders/RegistrationRoleProvider';
import { isRecordFound, useUserRoles } from '../../../hooks/data-hooks';
import { RecordDataIndicators } from '../../../components/RecordDataIndicators';
import { useOrganizationData } from '../../../data/DataProviders/OrganizationDataProvider';
import { isDataLoaded, UserRole } from '../../../types';
import { DataIndicators } from '../../../components/DataIndicators';

export const AddUserOrganization: React.FC = () => {
    const { t } = useLanguageLocale();
    const history = useHistory();
    const userRole = useUserRoles();
    const orgLocationData = useOrganizationData();
    const userId = getUserId(useAuthState());
    const [siteId, setSiteId] = React.useState('');
    const orgId = isDataLoaded(orgLocationData) ? orgLocationData.value.id : '';
    React.useEffect(() => {
        if (isRecordFound(userRole) && isDataLoaded(orgLocationData)) {
            setSiteId(orgLocationData.value.id);
            const isLocationAdmin = userRole.value.filter((x) => x.roleName === UserRole.LocationAdmin);
            if (isLocationAdmin.length > 0) {
                setSiteId(isLocationAdmin[0].siteId);
            }
        }
    }, [userRole, orgLocationData]);

    return (
        <>
            <GenericToolbar
                title={t('ADDUSER.TITLE')}
                subtitle={'User Management'}
                showBackButton
                backButtonOnClick={(): void => {
                    pushAppRoute(history, {
                        type: 'ManageUser',
                        orgId: orgId,
                    });
                }}
            />
            <RecordDataIndicators
                recordData={userRole}
                errorMessage="No Data"
                notFoundIcon="Person"
                notFoundMessage="No Data"
            />

            <DataIndicators
                errorMessage="No Data"
                emptyMessage="No Data"
                data={orgLocationData}
                emptyIcon="Person"
                isEmpty={false}
            />
            {userId && siteId && (
                <DataProviderCache for={'RegistrationRole'}>
                    <RegistrationRoleProvider userId={userId} siteId={siteId}>
                        <AddUser />
                    </RegistrationRoleProvider>
                </DataProviderCache>
            )}
        </>
    );
};
